import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSubHeader,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
  Separator,
  theme,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { ProgressRodRequestErrorProps } from './types';
import { ProgressRodRequestWeldErrorCode } from '@bechtel/types';
import { map } from 'lodash';

export const getErrorMessage = (error) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case ProgressRodRequestWeldErrorCode.INVALID_CREATED_BY:
      return <Trans>Invalid Created By Value.</Trans>;
    case ProgressRodRequestWeldErrorCode.INVALID_INPUT_DATA:
      return <Trans>Invalid Input Data.</Trans>;
    case ProgressRodRequestWeldErrorCode.INVALID_ROD_REQUEST_ID:
      return <Trans>Invalid Rod Request Id.</Trans>;
    case ProgressRodRequestWeldErrorCode.INVALID_ROD_REQUEST_WELD_STATUS:
      return <Trans>Invalid Rod Request Weld Status.</Trans>;
    case ProgressRodRequestWeldErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing Required Permission.</Trans>;
    case ProgressRodRequestWeldErrorCode.INVALID_WELD_ID:
      return <Trans>Invalid Weld Id.</Trans>;
    case ProgressRodRequestWeldErrorCode.PROGRESS_ROD_REQUEST_WELD_ERRORED:
      return <Trans>Error in Backend.</Trans>;
    case ProgressRodRequestWeldErrorCode.ROD_REQUEST_ALREADY_CLOSED_DELETED:
      return <Trans>Rod Request Already Closed/Deleted.</Trans>;
    case ProgressRodRequestWeldErrorCode.INVALID_PICKUP_TIME:
      return <Trans>Invalid Pickup Time.</Trans>;
    case ProgressRodRequestWeldErrorCode.INVALID_WELDER_ID:
      return <Trans>Invalid Welder.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const ProgressRodRequestError: FC<ProgressRodRequestErrorProps> = ({ error, onClose, errorRodRequests }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Progress Welds Error`}>
        <ModalClose onClick={onClose}></ModalClose>
      </ModalHeader>
      {errorRodRequests ? (
        <>
          <ModalBody>
            <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
              {map(errorRodRequests, (errorRodRequest) => (
                <Box flexDirection={{ sm: 'column' }} key={errorRodRequest.rodRequest?.requestNumber}>
                  <Box p={{ sm: '500' }}>
                    {errorRodRequest.rodRequest?.requestNumber && (
                      <Text weight="600" color="grey.1000">
                        {errorRodRequest.rodRequest?.requestNumber}&nbsp;:&nbsp;
                      </Text>
                    )}
                    <Box ml={{ sm: '200' }}>
                      <Text>{getErrorMessage(errorRodRequest?.errorCode)}</Text>
                    </Box>
                  </Box>
                  <Separator spacing="000" color="grey.200" size="100%" />
                </Box>
              ))}
            </Box>
          </ModalBody>
        </>
      ) : (
        <ModalBody>
          <Text size="500">
            <Trans>{getErrorMessage(error)}</Trans>
          </Text>
        </ModalBody>
      )}
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button
              appearance={ButtonAppearance.SECONDARY}
              onClick={onClose}
              css={`
                padding: 0 ${theme.spacings[500]} 0 ${theme.spacings[500]};
              `}
            >
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
